import { Ride } from './entities';
import { AppState } from '../../store';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { createRideTracker } from '@gtforge/ride-tracker-sdk';
import gatewayPath from '../../lib/network/env';

interface RequestError {
    message: string;
    status: number;
}

export const TRACKING_LOADED = 'TRACKING_LOADED';

export interface TrackingLoadedAction {
    type: LOAD_TRACKING;
    payload: Ride;
    error: string;
}

export enum LOAD_TRACKING {
    LOAD_TRACKING_REQUEST = 'LOAD_TRACKING_REQUEST',
    LOAD_TRACKING_SUCCESS = 'LOAD_TRACKING_SUCCESS',
    LOAD_TRACKINGE_ERROR = 'LOAD_TRACKINGE_ERROR',
}

export const thunkLoadTracking =
    (uuid: string, locale: string): ThunkAction<void, AppState, null, Action> =>
    async (dispatch) => {
        dispatch({
            type: LOAD_TRACKING.LOAD_TRACKING_REQUEST,
        });

        try {
            const req = {
                trackingId: uuid,
                locale: locale,
            };
            const rideTrackerSDK = createRideTracker(gatewayPath());

            const response = await rideTrackerSDK.getTracking(req);

            dispatch({
                type: LOAD_TRACKING.LOAD_TRACKING_SUCCESS,
                payload: response,
            });
        } catch (error) {
            const err = error as RequestError;
            const errMessage = err.message ? err.message : `Server error ${err.status}`;
            dispatch({
                type: LOAD_TRACKING.LOAD_TRACKINGE_ERROR,
                error: errMessage,
            });
        }
    };
